import { render, staticRenderFns } from "./VisiblePipesDescription.vue?vue&type=template&id=72565556&scoped=true"
import script from "./VisiblePipesDescription.vue?vue&type=script&lang=ts"
export * from "./VisiblePipesDescription.vue?vue&type=script&lang=ts"
import style0 from "./VisiblePipesDescription.vue?vue&type=style&index=0&id=72565556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72565556",
  null
  
)

export default component.exports